import { z } from '@hono/zod-openapi'

// id
export const idZ = z
  .number()
  .openapi({ description: 'チケットメッセージID', example: 10 })
export type id = z.infer<typeof idZ>

// ticketId
export const ticketIdZ = z
  .number()
  .openapi({ description: '紐づくチケットID', example: 42 })
export type ticketId = z.infer<typeof ticketIdZ>

// senderType
export const SENDER_TYPE_OWNER = 'owner'
export const SENDER_TYPE_ADMIN = 'admin'
export const SENDER_TYPE_SYSTEM = 'system'

export const senderTypeZ = z
  .enum([SENDER_TYPE_OWNER, SENDER_TYPE_ADMIN, SENDER_TYPE_SYSTEM])
  .openapi({ example: SENDER_TYPE_OWNER, description: '送信者種別' })
export type senderType = z.infer<typeof senderTypeZ>

// message
export const messageZ = z.string().openapi({
  description: 'メッセージ本文',
  example: '写真を確認しました。修繕業者を手配します。',
})
export type message = z.infer<typeof messageZ>

// readAt
export const readAtStringZ = z.string().nullable().openapi({
  description: '既読日時（ISO8601）。null は未読',
  example: '2024-05-20T10:00:00.000Z',
})
export type readAtString = z.infer<typeof readAtStringZ>

export const readAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: '2024-05-20T10:00:00.000Z' })
export type readAtDate = z.infer<typeof readAtDateZ>

// deletedAt
export const deletedAtStringZ = z.string().nullable().openapi({
  description: '削除日時（ISO8601）。null は未削除',
  example: '2024-05-20T10:00:00.000Z',
})
export type deletedAtString = z.infer<typeof deletedAtStringZ>

export const deletedAtDateZ = z
  .date()
  .nullable()
  .openapi({ example: '2024-05-20T10:00:00.000Z' })
export type deletedAtDate = z.infer<typeof deletedAtDateZ>

// createdAt
export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-05-20T09:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-05-20T09:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt
export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-05-20T09:30:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-05-20T09:30:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>

// ownerId
export const ownerIdZ = z.string().nullable().openapi({
  description: '送信者がオーナーの場合のオーナーID',
  example: '00000000-0000-0000-0000-000000000000',
})
export type ownerId = z.infer<typeof ownerIdZ>

// adminId
export const adminIdZ = z.string().nullable().openapi({
  description: '送信者が管理者の場合の管理者ID',
  example: 'a4f2f2e6-2d5a-4c5f-a2dd-1234567890ab',
})
export type adminId = z.infer<typeof adminIdZ>

export const uploadFileZ = z
  .object({
    path: z.string().openapi({ example: 'tmp/uuid' }),
    fileName: z.string().openapi({ example: 'test.pdf' }),
  })
  .optional()
  .openapi({ example: [{}] })
export type uploadFile = z.infer<typeof uploadFileZ>
